export const GAME_TYPE_LEAGUE = 'league.classic'
export const GAME_TYPE_KO = 'ko.classic'

import gameMode from "./gameModeMixin"

export default {
  methods: {
    getParticipantFromGameByUid(game, uid, defaultVal) {
      if (gameMode.methods.gameModeIsAnyTeamMode(game.mode)) { // TODO: This should not happen here, maybe implement getPlayerOrTeamByUid(game, playerOrTeam, defaultVal) ?
        return defaultVal
      }
      var ret = game.participants.find((e) => {
        return e.uid == uid
      })
      return ret ? ret : defaultVal
    }
  }
}
